import styled from 'styled-components'

const ProfileContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);

  h2 {
    font-weight: 300;
    font-size: 32px;
    text-align: center;
  }
`

export { ProfileContainer }
